"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "getLogger", {
    enumerable: true,
    get: function() {
        return getLogger;
    }
});
var _to_consumable_array = require("@swc/helpers/_/_to_consumable_array");
/**
 * Build an error log function that will:
 * - write an error msg to the console
 * - throw an error when in "debug" mode
 *
 * @param debug - a boolean parameter controlling whether to throw an error or not
 * @param log - an error logging function (console.error by default)
 * Returns function accepting a message to log to console and to eventually
 * throw an Error
 */ var errorLogger = function(debug, log) {
    return function(errorMsg) {
        log(errorMsg);
        if (debug) {
            throw new Error(JSON.stringify(errorMsg));
        }
    };
};
/**
 * Build a debug log function that will write to the console only when in "debug" mode
 *
 * @param debug - a boolean parameter controlling whether to show the message in console or not
 * @param log - a logging function (console.log by default)
 * Returns a function accepting a message to eventually log to console
 */ var debugLogger = function(debug, log) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (debug) {
            log.apply(void 0, _to_consumable_array._(args));
        }
    };
};
/**
 * Build an info log function that will write to the console (not impacted by the "debug" mode)
 *
 * @param {function} log - a logging function (console.log by default)
 * Returns a function accepting a message to eventually log to console
 */ var infoLogger = function(log) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        log.apply(void 0, _to_consumable_array._(args));
    };
};
var getDefaultLoggingFunctions = function() {
    return {
        errorFn: console.error,
        debugFn: console.log,
        infoFn: console.info
    };
};
/**
 * Build a logger object exposing an error log and a debug log function
 *
 * @param debug - a boolean parameter controlling the behaviour of logging functions
 * @param obj - default logging functions used in our loggers
 */ var getLogger = function() {
    var debug = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : getDefaultLoggingFunctions(), errorFn = _ref.errorFn, debugFn = _ref.debugFn, infoFn = _ref.infoFn;
    return {
        error: errorLogger(debug, errorFn),
        debug: debugLogger(debug, debugFn),
        info: infoLogger(infoFn)
    };
};

//# sourceMappingURL=logger.js.map